<script setup lang="ts">
import NoPatientImage from "@/Assets/images/chat/no_patients.svg";
</script>

<template>
  <div class="empty-list">
    <p class="empty-list__title">{{ $t("chat.assignment.no_new_patients") }}</p>
    <img class="empty-list__image" :src="NoPatientImage" :alt="$t('chat.assignment.no_new_patients')" />
  </div>
</template>

<style scoped lang="scss">
.empty-list {
  @include sp.padding(false, 4);

  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: center;

  &__title {
    @include sp.margin(t, 2);
    @include text.general(high, l);
    @include colors.color(content, high);
  }

  &__image {
    @include sp.margin(t, 4);
    @include sp.padding(false, 2);
  }
}
</style>
